import {
  IBoardRankingEntry,
  IBoardRankingGroup,
} from '../../../dtos/IBoardSnapshot';
import { groupKey } from './labels';

export interface IRankingPageGroup {
  key: string;
  group: IBoardRankingGroup;
  entries: IBoardRankingEntry[];
  /** Parte e total, quando um grupo grande ocupa mais de uma página. */
  part: number;
  parts: number;
}

export type IRankingPage = IRankingPageGroup[];

/** Linhas "gastas" pelo título de cada grupo. */
const TITLE_ROWS = 2;

/**
 * Distribui os grupos modalidade × categoria em páginas que cabem na tela.
 * Grupos pequenos dividem a página; um grupo maior que a página é fatiado
 * ("parte 1/2"). Sem grupos, uma página vazia — a tela mostra o estado vazio.
 */
export function paginateGroups(
  groups: IBoardRankingGroup[],
  rowsPerPage: number,
): IRankingPage[] {
  const capacity = Math.max(rowsPerPage, TITLE_ROWS + 1);
  const perSlice = capacity - TITLE_ROWS;
  const pages: IRankingPage[] = [];
  let current: IRankingPage = [];
  let used = 0;

  for (const group of groups) {
    const slices: IBoardRankingEntry[][] = [];
    for (let i = 0; i < Math.max(group.entries.length, 1); i += perSlice) {
      slices.push(group.entries.slice(i, i + perSlice));
    }

    slices.forEach((entries, index) => {
      const rows = TITLE_ROWS + Math.max(entries.length, 1);

      if (used + rows > capacity && current.length > 0) {
        pages.push(current);
        current = [];
        used = 0;
      }

      current.push({
        key: groupKey(group),
        group,
        entries,
        part: index + 1,
        parts: slices.length,
      });
      used += rows;
    });
  }

  if (current.length > 0 || pages.length === 0) pages.push(current);

  return pages;
}

/** Página onde está a equipe (para focar o grupo antes de animar). */
export function pageOfTeam(pages: IRankingPage[], teamId: string): number {
  return pages.findIndex(page =>
    page.some(item => item.entries.some(e => e.team_id === teamId)),
  );
}
